import Checkbox, { CheckboxProps } from '@anm/components/form/Checkbox';
import { FC } from 'react';
import styled from 'styled-components';

export type ConfirmCheckboxProps = CheckboxProps & { title: string; placeholder?: string; onClick?: () => void };

const Label = styled.span``;

const Container = styled.div`
  margin-left: 10px;
`;

const Wrapper = styled.div`
  display: flex;
  align-items: baseline;
  font-size: 16px;
  line-height: 25px;
  cursor: pointer;
`;

const CheckboxWrapper = styled(Checkbox)`
  top: 4px;
`;

const ConfirmCheckbox: FC<ConfirmCheckboxProps> = ({ title, checked, placeholder, onClick, ...otherProps }) => (
  <Wrapper onClick={onClick}>
    <CheckboxWrapper checked={checked} {...otherProps} />
    <Container>
      <Label>{title}</Label>
    </Container>
  </Wrapper>
);

export default ConfirmCheckbox;
